import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import WorkflowDashboard from "./WorkflowDashboard";

function App() {
  return (
    <Routes>
      <Route path="/" element={<WorkflowDashboard />} />
      <Route path="/:module" element={<ModuleLanding />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function ModuleLanding() {
  const location = useLocation();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#020617",
        color: "#e2e8f0",
        fontFamily: "'Segoe UI', system-ui, sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2 style={{ marginBottom: 8 }}>Module Route Loaded</h2>
        <p style={{ margin: 0, color: "#7dd3fc" }}>{location.pathname}</p>
      </div>
    </div>
  );
}

export default App;